<div class="dashboard-loader" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
  <mat-spinner [diameter]="diameter" [strokeWidth]="strokeWidth"></mat-spinner>
  <p>{{ title }}</p>
</div>
